import aminaPic from "@/public/images/artists/amina.png";
import { Artist } from "@/types/types";

export const amina = {
  id: "130",
  name: "Amina",
  image: aminaPic,
  description: `Amina's voice exudes a captivating blend of warmth and clarity, perfectly suited for modern pop and electronic genres. With smooth, expressive tones and a natural ability to convey emotion, Amina transitions effortlessly between melodic passages and upbeat sections. Her versatile vocal style brings a vibrant and dynamic quality to any track, making her an ideal choice for both lead and background vocals.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Famina-preview.mp3",
  meta: {
    // Must be free since artist is used in the tutorial
    free: true,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Unprocessed",
        "Jazz",
        "Indie",
        "RnB",
        "Hip Hop",
        "Pop",
        "Ethereal",
        "Falsetto",
        "Airy",
      ],
      secondary: ["Alluring"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 50,
        high: 75,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
